// The API sends dates as 'YYYY-MM-DD' and times as 'HH:MM:SS' strings (already
// in IST). They're formatted by hand rather than through `new Date(...)` so the
// shown value never shifts with the viewer's own timezone.

export function formatAuctionDate(date?: string | null): string {
  if (!date) return '—';
  const [y, m, d] = String(date).slice(0, 10).split('-');
  if (!y || !m || !d) return String(date);
  return `${d}-${m}-${y}`;
}

export function formatAuctionTime(time?: string | null): string {
  if (!time) return '—';
  const [h, m] = String(time).split(':');
  const hour = parseInt(h, 10);
  if (Number.isNaN(hour) || m === undefined) return String(time);
  const suffix = hour >= 12 ? 'PM' : 'AM';
  return `${hour % 12 || 12}:${m.slice(0, 2)} ${suffix}`;
}

// 'YYYY-MM-DD HH:MM:SS' bid timestamp -> '3:07:42 PM'
export function formatBidClock(dateTime?: string | null): string {
  if (!dateTime) return '—';
  const timePart = String(dateTime).split(/[ T]/)[1];
  if (!timePart) return '—';
  const [h, m, s] = timePart.split(':');
  const hour = parseInt(h, 10);
  if (Number.isNaN(hour)) return '—';
  const suffix = hour >= 12 ? 'PM' : 'AM';
  return `${hour % 12 || 12}:${m}:${(s || '00').slice(0, 2)} ${suffix}`;
}

export function formatAmount(currency: string, amount: number | string | null | undefined): string {
  if (amount === null || amount === undefined || amount === '') return '—';
  const n = typeof amount === 'number' ? amount : parseFloat(amount);
  if (Number.isNaN(n)) return '—';
  const symbol = currency === 'INR' || currency === '₹' ? '₹' : currency === 'USD' ? '$' : `${currency} `;
  return `${symbol}${n.toLocaleString('en-IN')}`;
}
